export function calculateDailyIntake(nutritionProfile) {
  if (nutritionProfile?.type === 'advanced') {
    return {
      kcal: nutritionProfile.advanced.kcal,
      protein: nutritionProfile.advanced.protein,
      fat: nutritionProfile.advanced.fat,
      carbs: nutritionProfile.advanced.carbs,
      fiber: nutritionProfile.advanced.fiber,
      isDefault: false,
    };
  }

  if (nutritionProfile?.type === 'standard' && nutritionProfile?.standard) {
    return {...calculateFromStandardProfile(nutritionProfile.standard), isDefault: false};
  }

  const defaultProfile = getDefaultNutritionProfile();
  return {...calculateFromStandardProfile(defaultProfile), isDefault: true};
}

function calculateFromStandardProfile(profile) {
  const age = calculateAge(profile.birthday);  

  const bmr = calculateBMR(age, profile.sex, profile.height, profile.weight);
  const tdee = calculateTDEE(bmr, profile.activity_level);

  const protein = calculateProtein(profile.weight, tdee);
  const fat = calculateFat(tdee);
  const carbs = calculateCarbs(tdee, protein, fat);

  return {
    kcal: Math.round(tdee),
    protein: Math.round(protein * 10) / 10,
    fat: Math.round(fat * 10) / 10,
    carbs: Math.round(carbs * 10) / 10,
    fiber: calculateFiber(age, profile.sex),
  };
}

function getDefaultNutritionProfile() {
  const age = 30;
  return {
    birthday: new Date(new Date().setFullYear(new Date().getFullYear() - age)),
    sex: 'male',
    height: 175,
    weight: 75,
    activity_level: 'moderately_active',
  };
}

function calculateAge(birthday) {  
  const birthDate = new Date(birthday);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }  
  return isNaN(age) ? 30 : age;
}

function calculateBMR(age, sex, heightInCm, weightInKg) {
  if (sex === 'female') {
    return 10 * weightInKg + 6.25 * heightInCm - 5 * age - 161;
  }
  return 10 * weightInKg + 6.25 * heightInCm - 5 * age + 5;
}

function calculateTDEE(bmr, activityLevel) {
  const activityFactors = {
    sedentary: 1.2,
    lightly_active: 1.375,
    moderately_active: 1.55,
    very_active: 1.725,
    extremely_active: 1.9,
  };
  return bmr * (activityFactors[activityLevel] || 1.55);
}

function calculateProtein(weightInKg, tdee) {
  const proteinPerKg = 1.6;
  const proteinFromWeight = weightInKg * proteinPerKg;
  const proteinFromCalories = (tdee * 0.15) / 4;
  return Math.max(proteinFromWeight, proteinFromCalories);
}

function calculateFat(tdee) {
  return (tdee * 0.25) / 9;
}

function calculateCarbs(tdee, protein, fat) {
  const proteinCalories = protein * 4;
  const fatCalories = fat * 9;
  return (tdee - proteinCalories - fatCalories) / 4;
}

function calculateFiber(age, sex) {
  if (sex === 'female') {
    if (age < 50) return 25;
    return 21;
  }
  if (age < 50) return 38;
  return 30;
}

